const reimburse = {
  plCode: '请输入编码',
  plName: '请输入名称',
  plDesc: '请输入描述',
  disableTip: '确定禁用该类目吗',
  disableConfirm: '禁用确认',
  disableConfirmContent: '确定禁用类目',
  disableSuccess: '禁用成功',
  disableSuccessDesc: '已禁用',
  disableFailed: '禁用失败',
  disableFailedHasSubs: '该类目存在子类目，无法禁用',
  addSuccessDesc: '添加成功',
  updateSuccessDesc: '更新成功',
  addFailed: '添加失败',
  codeDuplicate: '编码重复',
  applicationTypeLabel: '申请类型',
  approveTypeLabel: '审批方式',
  stepCount: '步骤数',
  reimbursement: '报销申请',
  dailySupplies: '日用品/物料申请',
  materialOverIssue: '超领领料申请',
  addMaterialOverIssue: '新增超领申请',
  materialOverIssueList: '超领申请列表',
  inOrder: '按顺序审批',
  any: '任一步骤同意',
  last: '最终步骤同意',
  templateConfig: '模板配置',
  approvalSteps: '审批步骤',
  step: '步骤',
  addStep: '添加步骤',
  specificOrgAnyone: '指定组织任何人',
  applicantOrgAnyone: '申请人组织任何人',
  specificUsers: '选定多个人',
  plSelectOrg: '请输入组织ID',
  plOrgId: '组织ID',
  plSelectUsers: '请选择用户',
  number: '单号',
  title: '标题',
  status: '状态',
  statusAll: '全部',
  statusDraft: '草稿',
  statusPending: '待审批',
  statusApproved: '已审批',
  statusRejected: '已拒绝',
  statusReturned: '已退回',
  applicationList: '申请列表',
  addApplication: '新增申请',
  plTitle: '请输入标题',
  plContent: '请输入内容',
  plPurpose: '请输入用途',
  plRemark: '请输入备注',
  content: '内容',
  purpose: '用途',
  remark: '备注',
  items: '物料明细',
  itemList: '申请项目列表',
  count: '数量',
  selectProducts: '按料号添加',
  plSelectProducts: '请选择物料',
  submit: '提交',
  reSubmit: '重新提交',
  submitSuccess: '提交成功',
  submitFailed: '提交失败',
  amount: '金额',
  orderAmount: '应领数量',
  productId: '物料ID',
  requirementItemId: '需求清单项',
  overCount: '超领数量',
  reasonType: '超领原因',
  reasonMistake: '失误',
  reasonWaste: '浪费',
  reasonOther: '其他',
  reason: '详细说明',
  picked: '已生成出库单',
  pickedYes: '是',
  pickedNo: '否',
  expenseDate: '费用日期',
  invoiceCount: '发票数量',
  plAmount: '请输入金额',
  plInvoiceCount: '请输入发票数量',
  plExpenseDate: '请选择费用日期',
  atLeastOne: '至少保留一项',
  submitConfirm: '确定提交报销单吗？',
  submitOverIssueConfirm: '确定提交超领申请吗？',
  addDailyItem: '无料号添加',
  approver: '审批人',
  actualApprover: '实际审批人',
  approveTime: '审批时间',
  approveOrg: '审批组织',
  applicant: '申请人',
  submitTime: '提交时间',
  completeTime: '完成时间',
  stepNo: '步骤',
  pass: '通过',
  reject: '拒绝',
  return: '退回',
  passSuccess: '已通过',
  rejectSuccess: '已拒绝',
  returnSuccess: '已退回',
  passFailed: '通过失败',
  rejectFailed: '拒绝失败',
  returnFailed: '退回失败',
  confirmPass: '确定通过该审批吗？',
  confirmReject: '确定拒绝该审批吗？',
  confirmReturn: '确定退回该审批吗？',
  approveRemark: '审批备注',
  plApproveRemark: '请输入审批备注',
  timeout: '超时时间',
  approvalTimeLimit: '审批时限',
  enableConfirm: '启用确认',
  disableCascadeTip: '禁用该类目会同步禁用该类目下的所有类目',
  enableCascadeTip: '启用该类目会同步启用该类目下的所有类目',
};

export default reimburse;
